// Kho & LOT (nhập kho theo lô). Quy tắc W-R01…W-R09 chốt 20/09/2026 theo chuẩn — khách bác lại được; xem PROJECT_DECISIONS.
export const warehouseEn={
 remove:'Remove',
 showClosed:'Include cancelled / reversed',
 reversed:'Reversed',
 cancelled:'Cancelled',
 reverse:'Reverse receipt',
 cancelDraft:'Cancel draft',
 closeTitle:'Close this receipt',
 closeHint:'Cancelling a draft needs the Edit tick. Reversing a confirmed receipt needs the Approve tick and is only possible while its LOTs are unused (not inspected, moved or issued); the original and its history are kept.',
 reason:'Reason',
 closeAction:'Confirm closure',
 reasonRequired:'Enter a reason of at least 5 characters.',
 closed:'Closed receipt — original details and audit history retained.',
 pProcessOn:'Enabled',
 pProcessOff:'Disabled',
 title:'Warehouse receiving',
 subtitle:'Receive purchase-order goods by LOT and storage location. Received goods wait for inspection before use.',
 receipts:'Goods receipts',
 balances:'LOT balances',
 review:'Customer review',
 catalog:'Warehouse directory',
 newReceipt:'New receipt',
 receiptNo:'Receipt',
 po:'Purchase order',
 supplier:'Supplier',
 warehouse:'Warehouse',
 status:'Status',
 date:'Receipt date',
 deliveryNote:'Supplier delivery-note number',
 notes:'Notes',
 save:'Save draft',
 confirm:'Confirm receipt',
 confirmTitle:'Confirm this receipt?',
 confirmDescription:'Records these quantities once as awaiting inspection on each LOT. A confirmed receipt cannot be edited; if something is wrong, reverse it and receive again.',
 confirmed:'Confirmed',
 draft:'Draft',
 search:'Search receipt, PO or supplier',
 searchLot:'Search LOT, product or warehouse',
 searchPo:'Search PO number or supplier',
 select:'Select…',
 product:'Product / Sub ref',
 lot:'Supplier LOT on the goods',
 location:'Storage location',
 quantity:'Received quantity',
 unit:'PO unit',
 ordered:'Ordered',
 received:'Already received',
 remaining:'Remaining',
 addLine:'Add allocation',
 removeUnsaved:'Remove unsaved allocation',
 empty:'No records match.',
 previous:'Previous',
 next:'Next',
 page:'Page {{page}} · up to 50 rows',
 moreSources:'More than 100 POs match. Refine the search.',
 back:'Back to warehouse',
 edit:'Open receipt',
 invalid:'Select a PO and warehouse; add at least one allocation with a LOT, location and positive quantity (up to 4 decimals).',
 error:'Unable to load or save receiving data.',
 pending:'Awaiting customer confirmation',
 rule:'Rule',
 defaultRule:'Current proposal',
 question:'Question for customer',
 basis:'Basis: source paperwork and traceability design review',
 reviewIntro:'These working defaults are proposals, not customer-approved rules. Confirmation is recorded with the project owner before these markers are removed.',
 scope:'New receipt ledger only. Quarantined quantities are not available stock and are not added to the existing product balance. Opening stock has not been reconciled.',
 documents:'Receipt scans, arrival time and inspection are recorded in Incoming QC & documents (Quality).',
 locked:'Confirmed receipt — quantities and LOTs are locked. To correct it, reverse the receipt and receive again.',
 readOnly:'Confirming a receipt needs the Approve tick on Warehouse & LOT.',
 unsaved:'Leave without saving?',
 unsavedBody:'This receipt has unsaved changes.',
 stay:'Keep editing',
 leave:'Leave page',
 saveFirst:'Save changes before confirming.',
 sourceChanged:'PO source changed or is no longer eligible. Review the PO before confirming.',
 overallocated:'Received quantities exceed the PO balance. Refresh and review other receipts.',
 changed:'Another user changed this draft. Reload before saving.',
 retry:'This request ID was used for another draft. Reload and review the existing receipt.',
 lineRemoval:'Saved allocations cannot be removed in this slice; edit the allocation or request an approved correction.',
 sourceLocked:'The PO has confirmed goods receipts. Its source identity, quantity or archive state cannot be changed.',
 quantityError:'Enter a positive quantity with at most 4 decimal places, without grouping separators.',
 rulesTitle:'Rules in force',
 rulesDecided:'Settled 20/09/2026',
 needsApprove:'Confirming needs the Approve tick on Warehouse & LOT — the receipt stays a draft until someone with it confirms.',
 noLotHint:'No LOT printed by the supplier? Enter their delivery-note number.',
 statusLine:'{{status}} · {{lines}} allocation(s)',
 iqcNext:'These LOTs are awaiting inspection. Record the incoming inspection (IQC) to release accepted quantities; print LOT labels for the goods.',
 groups:{source:'Purchase order and warehouse',sourceHint:'Which order, which warehouse, when, and the supplier\'s delivery note.',lines:'Goods received by LOT',linesHint:'One allocation per order line, LOT, quantity and location. Goods from several LOTs: add an allocation per LOT.',after:'Inspection and labels',afterHint:'Received goods are usable only after the inspection decision.'},
 rules:{
  intake:{title:'Receive against a purchase order, split by LOT',body:'Receipts are raised from a sent, confirmed or partly delivered purchase order — no goods are received without one. Each allocation is one order line, one LOT, a quantity and a location; goods from several LOTs get one allocation per LOT. Received never exceeds ordered: for an over-delivery, purchasing raises a supplementary order (or amends the order while nothing is confirmed on it) or the excess goes back; for a short delivery the order waits for the rest. Confirming needs the supplier\'s delivery-note number.'},
  lot:{title:'Supplier LOT and exact quantities',body:'Everything received is tracked by LOT, even when the order is not linked to a PI. Enter the supplier\'s LOT exactly as printed (leading zeros kept); the same LOT, product and supplier is one LOT across receipts — a different supplier or product is a different LOT. No LOT printed: enter the supplier\'s delivery-note number. Quantities are in the order\'s unit, up to 4 decimals, never converted automatically.'},
  quarantine:{title:'New receipts wait for inspection',body:'Confirming puts the goods into each LOT\'s awaiting-inspection stock. Only an approved incoming inspection (IQC) releases the accepted quantity and sets rejects aside — receiving never assumes a pass. No product or supplier is exempt from inspection yet. Who inspects and who approves results is settled under Quality.'},
  correction:{title:'Corrections and opening stock',body:'A confirmed receipt is never edited: for a wrong LOT or quantity, reverse it with a reason and receive again — possible only while its LOTs are uninspected, unmoved and unused. Warehouse & LOT is the only stock source (since 18/09/2026); opening stock is loaded once from a physical count sheet under Stock movements, and goods with no known LOT go into an opening LOT OPEN-date-code-line.'},
  authority:{title:'Who can do what',body:'By the Warehouse & LOT ticks: View; Create to raise draft receipts; Edit to edit and cancel drafts; Approve to confirm receipts and reverse confirmed ones. Confirming records that goods arrived — it is not a money approval, so the person who raised the receipt may confirm it.'},
 },
};

export const warehouseVi={
 remove:'Bỏ',
 showClosed:'Hiện phiếu đã hủy / đảo',
 reversed:'Đã đảo',
 cancelled:'Đã hủy',
 reverse:'Đảo phiếu nhập',
 cancelDraft:'Hủy phiếu nháp',
 closeTitle:'Đóng phiếu nhập',
 closeHint:'Huỷ phiếu nháp cần ô Sửa. Đảo phiếu đã nhập cần ô Duyệt và chỉ làm được khi lô chưa kiểm, chưa chuyển, chưa dùng; giữ nguyên chứng từ gốc và lịch sử.',
 reason:'Lý do',
 closeAction:'Xác nhận đóng phiếu',
 reasonRequired:'Nhập lý do ít nhất 5 ký tự.',
 closed:'Phiếu đã đóng — giữ chi tiết gốc và lịch sử.',
 pProcessOn:'Bật',
 pProcessOff:'Tắt',
 title:'Nhập kho theo LOT',
 subtitle:'Nhận hàng của đơn mua theo LOT và vị trí. Hàng mới nhận chờ kiểm rồi mới dùng được.',
 receipts:'Phiếu nhập kho',
 balances:'Số dư theo LOT',
 review:'Chờ khách xác nhận',
 catalog:'Danh mục kho',
 newReceipt:'Tạo phiếu nhập',
 receiptNo:'Phiếu nhập',
 po:'Đơn mua hàng',
 supplier:'Nhà cung cấp',
 warehouse:'Kho',
 status:'Trạng thái',
 date:'Ngày nhận hàng',
 deliveryNote:'Số phiếu giao hàng của nhà cung cấp',
 notes:'Ghi chú',
 save:'Lưu nháp',
 confirm:'Xác nhận nhập',
 confirmTitle:'Xác nhận phiếu nhập này?',
 confirmDescription:'Ghi số lượng vào tồn chờ kiểm của từng LOT, một lần. Phiếu đã xác nhận không sửa được; sai thì đảo phiếu rồi lập phiếu mới.',
 confirmed:'Đã nhập',
 draft:'Nháp',
 search:'Tìm phiếu nhập, PO hoặc nhà cung cấp',
 searchLot:'Tìm LOT, sản phẩm hoặc kho',
 searchPo:'Tìm số PO hoặc nhà cung cấp',
 select:'Chọn…',
 product:'Sản phẩm / Mã phụ',
 lot:'Số lô nhà cung cấp trên hàng',
 location:'Vị trí lưu kho',
 quantity:'Số lượng thực nhận',
 unit:'Đơn vị trên PO',
 ordered:'Đã đặt',
 received:'Đã nhận',
 remaining:'Còn nhận',
 addLine:'Thêm phân bổ',
 removeUnsaved:'Bỏ phân bổ chưa lưu',
 empty:'Không có dữ liệu phù hợp.',
 previous:'Trước',
 next:'Sau',
 page:'Trang {{page}} · tối đa 50 dòng',
 moreSources:'Có hơn 100 PO phù hợp. Hãy tìm cụ thể hơn.',
 back:'Về quản lý kho',
 edit:'Mở phiếu nhập',
 invalid:'Chọn PO, kho và ít nhất một phân bổ có LOT, vị trí, số lượng dương (tối đa 4 số lẻ).',
 error:'Không thể tải hoặc lưu dữ liệu nhập kho.',
 pending:'Chờ khách xác nhận',
 rule:'Quy tắc',
 defaultRule:'Đề xuất đang dùng',
 question:'Câu hỏi cho khách',
 basis:'Căn cứ: biểu mẫu gốc và bản rà soát thiết kế truy xuất',
 reviewIntro:'Đây là quy tắc đề xuất đang chạy, chưa phải khách đã duyệt. Chỉ gỡ dấu khi chủ dự án ghi nhận xác nhận của khách.',
 scope:'Chỉ là sổ nhập mới. Lượng chờ QC chưa được dùng và chưa cộng vào tồn sản phẩm hiện có. Tồn đầu kỳ chưa được đối soát.',
 documents:'Bản scan chứng từ, giờ hàng đến và kết quả kiểm ghi ở IQC & hồ sơ nhận hàng (menu Chất lượng).',
 locked:'Phiếu đã xác nhận — khoá số lượng và LOT. Muốn sửa thì đảo phiếu rồi lập phiếu mới.',
 readOnly:'Xác nhận nhập cần ô Duyệt ở menu Kho & LOT.',
 unsaved:'Rời trang khi chưa lưu?',
 unsavedBody:'Phiếu nhập có thay đổi chưa lưu.',
 stay:'Tiếp tục sửa',
 leave:'Rời trang',
 saveFirst:'Lưu thay đổi trước khi xác nhận.',
 sourceChanged:'PO đã thay đổi hoặc không còn đủ điều kiện. Kiểm tra lại trước khi nhập.',
 overallocated:'Số lượng nhận vượt phần còn lại của PO. Tải lại và kiểm tra các phiếu khác.',
 changed:'Nháp đã được người khác sửa. Tải lại trước khi lưu.',
 retry:'Mã yêu cầu đã dùng cho nháp khác. Tải lại để kiểm tra phiếu hiện có.',
 lineRemoval:'Đợt này chưa cho bỏ phân bổ đã lưu; hãy sửa dòng hoặc yêu cầu điều chỉnh được duyệt.',
 sourceLocked:'PO đã có phiếu nhập xác nhận. Không được đổi định danh, số lượng nguồn hoặc lưu trữ PO.',
 quantityError:'Nhập số lượng dương, tối đa 4 số lẻ, không dùng dấu phân cách hàng nghìn.',
 rulesTitle:'Quy tắc áp dụng',
 rulesDecided:'Đã chốt 20/09/2026',
 needsApprove:'Xác nhận nhập cần ô Duyệt ở Kho & LOT — phiếu nằm nháp cho tới khi người có ô đó xác nhận.',
 noLotHint:'Nhà cung cấp không ghi số lô thì ghi số phiếu giao của họ.',
 statusLine:'{{status}} · {{lines}} phân bổ',
 iqcNext:'Các lô này đang chờ kiểm. Ghi kết quả kiểm đầu vào (IQC) để cho dùng phần đạt; in tem lô dán lên hàng.',
 groups:{source:'Đơn mua và kho',sourceHint:'Nhận theo đơn mua nào, vào kho nào, ngày nào, phiếu giao của nhà cung cấp.',lines:'Hàng nhận theo LOT',linesHint:'Mỗi phân bổ là một dòng đơn mua, một LOT, số lượng và vị trí. Hàng về nhiều lô thì thêm phân bổ cho từng lô.',after:'Kiểm đầu vào và tem lô',afterHint:'Hàng mới nhận chỉ dùng được sau khi có kết quả kiểm.'},
 rules:{
  intake:{title:'Nhận theo đơn mua, tách theo LOT',body:'Phiếu nhập lập từ đơn mua đã gửi, đã xác nhận hoặc đang giao dở — không nhận hàng không có đơn mua. Mỗi phân bổ là một dòng đơn mua, một LOT, số lượng và vị trí; hàng về nhiều lô thì mỗi lô một phân bổ. Tổng nhận không vượt số đặt: giao thừa thì mua hàng lập đơn mua bổ sung (hoặc sửa đơn khi chưa có phiếu nhập nào xác nhận) hay trả lại phần thừa; giao thiếu thì đơn chờ phần còn lại. Xác nhận cần số phiếu giao của nhà cung cấp.'},
  lot:{title:'Số lô nhà cung cấp, số lượng chính xác',body:'Mọi hàng nhập kho đều theo LOT, kể cả khi đơn mua chưa gắn PI. Ghi đúng số lô in trên hàng của nhà cung cấp (giữ số 0 đầu); cùng số lô, cùng mã hàng, cùng nhà cung cấp là một lô qua nhiều lần nhập — khác nhà cung cấp hay khác mã là lô khác. Nhà cung cấp không ghi số lô thì ghi số phiếu giao của họ. Số lượng theo đúng đơn vị trên đơn mua, tối đa 4 số lẻ, không tự quy đổi.'},
  quarantine:{title:'Hàng mới nhận chờ kiểm',body:'Xác nhận nhập đưa hàng vào tồn chờ kiểm của từng lô. Chỉ kết quả kiểm đầu vào (IQC) đã duyệt mới cho dùng phần đạt và để riêng phần không đạt — nhận hàng không tự coi là đạt. Chưa có mã hàng hay nhà cung cấp nào được miễn kiểm. Ai kiểm, ai duyệt kết quả chốt ở mục Chất lượng.'},
  correction:{title:'Sửa sai và tồn đầu kỳ',body:'Phiếu đã xác nhận không sửa: sai số lô hay số lượng thì đảo phiếu (ghi lý do) rồi lập phiếu mới — chỉ đảo được khi lô chưa kiểm, chưa chuyển, chưa dùng. Kho & LOT là nguồn tồn duy nhất (từ 18/09/2026); tồn đầu kỳ nhập một lần từ phiếu đếm thực tế ở Biến động kho, hàng không rõ số lô vào lô tồn đầu OPEN-ngày-mã-dòng.'},
  authority:{title:'Ai được làm gì',body:'Theo ô tick menu Kho & LOT: Xem; Tạo để lập phiếu nháp; Sửa để sửa và huỷ phiếu nháp; Duyệt để xác nhận nhập và đảo phiếu đã nhập. Xác nhận là ghi nhận hàng đã về, không phải duyệt tiền — người lập phiếu có ô Duyệt tự xác nhận được.'},
 },
};

export const warehouseZh={
 remove:'移除',
 showClosed:'包含已取消／冲销',
 reversed:'已冲销',
 cancelled:'已取消',
 reverse:'冲销收货',
 cancelDraft:'取消草稿',
 closeTitle:'关闭收货单',
 closeHint:'取消草稿需要“编辑”勾选。冲销已确认的收货需要“审核”勾选，且批次尚未检验、调拨或使用；保留原单据及历史。',
 reason:'原因',
 closeAction:'确认关闭',
 reasonRequired:'请输入至少5个字符的原因。',
 closed:'单据已关闭，保留原始明细及历史。',
 pProcessOn:'启用',
 pProcessOff:'停用',
 title:'批次收货',
 subtitle:'依采购单按批次与库位收货。新收货品须待检验后才能使用。',
 receipts:'收货单',
 balances:'批次结存',
 review:'客户待确认',
 catalog:'仓库信息',
 newReceipt:'新增收货单',
 receiptNo:'收货单',
 po:'采购单',
 supplier:'供应商',
 warehouse:'仓库',
 status:'状态',
 date:'收货日期',
 deliveryNote:'供应商送货单号',
 notes:'备注',
 save:'保存草稿',
 confirm:'确认收货',
 confirmTitle:'确认此收货单？',
 confirmDescription:'数量一次记入各批次的待检库存。已确认的收货单不可修改；有误时请冲销后重新收货。',
 confirmed:'已收货',
 draft:'草稿',
 search:'搜索收货单、采购单或供应商',
 searchLot:'搜索批次、产品或仓库',
 searchPo:'搜索采购单号或供应商',
 select:'选择…',
 product:'产品 / 子参考',
 lot:'货品上的供应商批号',
 location:'库位',
 quantity:'实收数量',
 unit:'采购单单位',
 ordered:'订购数量',
 received:'已收数量',
 remaining:'待收数量',
 addLine:'新增批次分配',
 removeUnsaved:'移除未保存分配',
 empty:'没有符合的数据。',
 previous:'上一页',
 next:'下一页',
 page:'第 {{page}} 页 · 最多50条',
 moreSources:'超过100条符合，请缩小搜索范围。',
 back:'返回仓库',
 edit:'打开收货单',
 invalid:'请选择采购单、仓库并填写批次、库位与正数数量（最多4位小数）。',
 error:'无法加载或保存收货信息。',
 pending:'待客户确认',
 rule:'规则',
 defaultRule:'目前提案',
 question:'客户确认问题',
 basis:'依据：原始表单及追溯设计审查',
 reviewIntro:'这些运行中的默认规则尚未经客户审核，须由项目负责人记录确认后才移除标记。',
 scope:'仅新收货台账。待检数量尚不可使用，未加入原有产品结存，也尚未核对期初库存。',
 documents:'收货文件扫描、到货时间及检验结果记录于质量菜单的“IQC与收货文件”。',
 locked:'收货已确认，数量及批次已锁定。如需更正，请冲销后重新收货。',
 readOnly:'确认收货需要“仓库与批次”菜单的“审核”勾选。',
 unsaved:'放弃未保存变更？',
 unsavedBody:'收货单有未保存变更。',
 stay:'继续编辑',
 leave:'离开',
 saveFirst:'确认前请先保存。',
 sourceChanged:'采购单来源已变更或不再符合条件，请重新核对。',
 overallocated:'收货数量超过采购单余额，请重新加载并核对其他收货单。',
 changed:'草稿已被其他人修改，保存前请重新加载。',
 retry:'此请求识别码已用于其他草稿，请重新加载核对。',
 lineRemoval:'本阶段不可移除已保存分配，请修改或申请审核调整。',
 sourceLocked:'采购单已有确认收货，不可修改来源标识、数量或归档。',
 quantityError:'请输入正数，最多4位小数，不使用千位分隔符号。',
 rulesTitle:'适用规则',
 rulesDecided:'已于20/09/2026确定',
 needsApprove:'确认收货需要“仓库与批次”的“审核”勾选——在有此勾选的人确认前，收货单保持草稿。',
 noLotHint:'供应商未标示批号时，请填其送货单号。',
 statusLine:'{{status}} · {{lines}} 条分配',
 iqcNext:'这些批次待检中。记录来料检验（IQC）以放行合格数量；打印批次标签贴于货品。',
 groups:{source:'采购单与仓库',sourceHint:'依哪张采购单、入哪个仓库、何日，以及供应商送货单。',lines:'按批次收货',linesHint:'每条分配为一条订单明细、一个批次、数量及库位。多批次到货时，每个批次各加一条分配。',after:'来料检验与批次标签',afterHint:'新收货品须有检验结果后才可使用。'},
 rules:{
  intake:{title:'依采购单收货，按批次分配',body:'收货单从已发送、已确认或部分到货的采购单创建——没有采购单不收货。每条分配为一条订单明细、一个批次、数量及库位；多批次到货时每个批次一条分配。收货总量不得超过订购量：超交时由采购开立补充订单（或在尚无确认收货时修改订单），或退回多出部分；短交时订单等待其余数量。确认收货需填供应商送货单号。'},
  lot:{title:'供应商批号与精确数量',body:'所有入库货品一律按批次管理，即使采购单未关联PI。依货品上的供应商批号照填（保留前导零）；同一批号、同一产品、同一供应商于多次收货视为同一批次——供应商或产品不同即为不同批次。供应商未标示批号时填其送货单号。数量依采购单单位，最多4位小数，不自动换算。'},
  quarantine:{title:'新收货品待检',body:'确认收货后，货品记入各批次的待检库存。只有已审核的来料检验（IQC）才放行合格数量并隔离不合格品——收货本身不视为合格。目前没有产品或供应商可免检。由谁检验、由谁审核结果，于质量项目确定。'},
  correction:{title:'更正与期初库存',body:'已确认的收货单不修改：批号或数量有误时，填写原因冲销后重新收货——仅限批次尚未检验、调拨或使用。仓库与批次是唯一的库存来源（自18/09/2026起）；期初库存于库存变动依实地盘点表一次导入，批号不明的货品记入期初批次 OPEN-日期-代码-行。'},
  authority:{title:'谁可以做什么',body:'依“仓库与批次”菜单勾选：查看；“创建”开立收货草稿；“编辑”修改及取消草稿；“审核”确认收货及冲销已确认的收货。确认收货是记录货已到，不是金额审核——开单人若有“审核”勾选可自行确认。'},
 },
};
